import React, { useMemo } from 'react';
import type { FC } from 'react';
import { Link } from 'react-router-dom';
import DOMPurify from 'dompurify';

import type { NewsArticle } from '../../entities/news/model/types';
import styles from './NewsCard.module.scss';

const dateFormatter = new Intl.DateTimeFormat('ru-RU', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
});

export const NewsCard: FC<{ article: NewsArticle }> = ({ article }) => {
    const html = useMemo(
        () => DOMPurify.sanitize(article.description, { ADD_ATTR: ['target', 'rel'] }),
        [article.description],
    );

    const date = new Date(article.created_at);

    return (
        <article className={styles.card}>
            <time className={styles.date} dateTime={date.toISOString()}>
                {dateFormatter.format(date)}
            </time>

            <h3 className={styles.title}>
                <Link
                    to={`/news/${article.id}`}
                    state={{ article }}
                    className={styles.titleLink}
                >
                    {article.title}
                </Link>
            </h3>

            <div className={styles.body} dangerouslySetInnerHTML={{ __html: html }} />
        </article>
    );
};